import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "./api";
import { AppThunk } from "./app";
import API_URL from "../config/ApiUrl";
import axios from "axios";

interface NumberManagementState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as NumberManagementState;

const NumberManagementSlice = createSlice({
  name: "NumberManagement",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = NumberManagementSlice.actions;

export const fetchNumberManagement =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      // const response = await api.post(API_URL.NUMBER_MANAGEMENT.ADD, payload);

      const params = {
        asterisk_number: "12225236",
        shadow_number: "1599-505236",
      };

      const response = await axios.post(
        `https://fnr.paycall.co.il/api/?action=update_asterisk_number`,
        params,
        {
          headers: {
            accept: "application/json",
            Authorization: "Basic bnBnX2FwaTpucGdfY2FsbHM=",
          },
        }
      );

      // const response = await fetch('http://141.226.248.13:5005/numbers/add', {
      //   method: 'PUT',
      //   headers: {
      //     'Accept': 'application/json',
      //     'Content-Type': 'application/json',
      //     'Authorization': 'Basic bnBnX2FwaTpucGdfY2FsbHM='
      //   },
      //   body: JSON.stringify(payload)
      // });

      // if (!response.ok) {
      //   throw new Error('Network response was not ok');
      // }

      // const data = await response.json();

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

// API FOR NUMBER MANAGEMENT STARTS FROM HERE...

export const addNumberManagement =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.NUMBER_MANAGEMENT.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateNumberManagement =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.NUMBER_MANAGEMENT.UPDATE,
        payload
      );

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchNumberManagementList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const to_number = payload.to_number ? payload.to_number : "";
      const number = payload.number ? payload.number : "";
      const current = payload.current ? payload.current : "";
      const page_size = payload.page_size ? payload.page_size : "";

      const action = `?to_number=${to_number}&number=${number}&current=${current}&page_size=${page_size}`;

      const response = await api.get(API_URL.NUMBER_MANAGEMENT.LIST + action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

// API FOR INTERNAL NUMBER ROUTING STARTS FROM HERE...

export const fetchInternalNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.NUMBER_ROUTING.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateInternalNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.NUMBER_ROUTING.UPDATE, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const checkRoutingNumber =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const action = payload.action ? payload.action : "internal_whois";
      const number = payload.number ? payload.number : "";

      const act = `?number=${number}&action=${action}`;

      const response = await api.get(API_URL.NUMBER_ROUTING.LIST + act);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const insertBulkData =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.NUMBER_ROUTING.BULK_INSERT_CSV_DATA,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

// API FOR INTERNAL CODE STARTS FROM HERE...

export const addInternalCode =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.INTERNAL_CODE.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateInternalCode =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.INTERNAL_CODE.UPDATE, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const deleteInternalCode =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.INTERNAL_CODE.DELETE, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getInternalCodeList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const current = payload.current ? payload.current : "";
      const page_size = payload.page_size ? payload.page_size : "";
      const action = `?current=${current}&page_size=${page_size}`;

      const response = await api.get(
        API_URL.INTERNAL_CODE.LIST + (action ? action : null)
      );

      return Promise.resolve(response.data?.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

// API FOR ASTERISK CRUD STARTS FROM HERE...

export const addAsteriskNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.ASTERISK_NUMBER.ADD, payload);

      //    header = {
      //   ...header,
      //   accept: 'application/json',
      //   // 'Content-Type': 'application/json',
      //   'Content-Type': 'multipart/form-data',
      //   'Access-Control-Allow-Origin': '*',
      //   Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // };

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const statusAsteriskNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.ASTERISK_NUMBER.STATUS, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const deleteAsteriskNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.ASTERISK_NUMBER.DELETE, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getAsteriskNumberList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.ASTERISK_NUMBER.LIST, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getAsteriskViewStatusList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.ASTERISK_NUMBER.VIEW_STATUS,
        payload
      );

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateAsteriskStatus =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.ASTERISK_NUMBER.UPDATE_STATUS,
        payload
      );

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default NumberManagementSlice.reducer;
